import React from "react";
import videoc from "../../assets/video/tv-box.mp4";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import imagen from "../../assets/image/stella/installsmartv1.png";

function Question() {

    return (
        <>
            <section className="container px-5 py-20">
                <div className="text-center mb-10"><h4
                    className="text-[32px] md:text-[35px] leading-[1.1em] font-medium">Preguntas frecuentes</h4>
                    <div className="mt-3 flex items-center gap-[5px] w-max mx-auto text-white">
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-10 h-1 rounded-xs"></div>
                    </div>
                    <p className="mt-4 mx-auto leading-relaxed text-white">Aquí tiene todas las respuestas a las dudas sobre cómo
                        funciona y la compatibilidad de magis tv en un smart tv.</p></div>
                <div className="mt-16 grid md:grid-cols-2 gap-[30px] px-[15px]">
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        descargar Stella TV en smart tv?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-white leading-relaxed">
                            <p className="whitespace-pre-line">Solo podrá <b>descargar la aplicación de Stella TV en su
                                smart tv</b>, siempre y cuando tenga sistema Android. Si no tiene este sistema operativo
                                no lo podrá realizar la descarga.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Funciona
                        en TV Samsung o LG?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-white leading-relaxed">
                            <p className="whitespace-pre-line">La aplicación de magis tv no funciona
                                en <b>Samsung</b> con <b>Tizen</b> o <b>LG</b> con <b>WebOS</b>. Solo podría tener la
                                app si compra una tv box, chromecast o fire stick y en dichos gadgets instala la app.
                            </p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Qué
                        modelo de TV tiene Android?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-white leading-relaxed">
                            <p className="whitespace-pre-line">Los smart tv que recomendamos que tienen sistema
                                operativo Android son: últimos modelos de Sony bravia, Xiaomi TV y JVC, Hisense.
                                (existen más marcas, pero no las hemos probado)</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">Error /
                        Falla de la app mi smart tv</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-white leading-relaxed">
                            <p className="whitespace-pre-line">Si tiene alguna falla del servicio le recomendamos lo
                                siguiente: verificar la red de internet, limpiar la memoria cache de la app desde sus
                                ajustes y revisar que tengamos la última versión.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Puedo
                        ver gratis Stella TV en smart tv?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-white leading-relaxed">
                            <p className="whitespace-pre-line">NO SE PUEDE. El servicio que ofrecemos es de pago, por
                                ende es necesario comprar una suscripción para poder ver todo el contenido que ofrece de
                                manera ilimitada y en HD.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Se
                        puede transmitir del móvil a la TV?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-white leading-relaxed">
                            <p className="whitespace-pre-line">NO SE PUEDE. La única forma de transmitir los contenidos
                                de Stella TV desde el móvil a la pantalla de una T.V es usando el modo espejo con un
                                google chromecast.</p></div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Question;
